import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AssociationsService } from 'app/services/associations.service';
import { AssociationHelper } from 'app/storage/association.storage';
import { SessionStorage } from 'app/storage/session.storage';
import { fromEventPattern, lastValueFrom } from 'rxjs';
import { MeetingFormService } from '../meeting-form.service';

@Component({
  selector: 'first-meeting',
  templateUrl: './first-meeting.component.html',
  styleUrls: ['./first-meeting.component.scss']
})
export class FirstMeetingComponent implements OnInit {

  form!: FormGroup
  loading: boolean = true

  constructor(
    private fb: FormBuilder,
    private formService: MeetingFormService,
    private service: AssociationsService,
    private helper: AssociationHelper,
    private router: Router,
    public auth: SessionStorage,
  ) {
    this.formService.clear() 
    this.form = this.fb.group({
      dateSetted: [false, Validators.required],
      date: ['', Validators.required],
      meetingCompleted: [false, Validators.required],
/*
      'Question 1': ['', Validators.required],
      'Question 2': new FormArray([]),
      'Question 3': ['', Validators.required],
      'Question 45': new FormArray([]),
      'Materials': new FormArray([])
*/
    })
    this.formService.setForm(this.form)
    
  }

  async ngOnInit() {

    if(!this.helper.getSelectedProject() || !this.helper.getSelectedEpe()){
      this.router.navigateByUrl(`assigned-services`)
      this.loading = false
      return
    }

    let response = await lastValueFrom(this.service.getForm(this.helper.getSelectedProject(), this.helper.getSelectedEpe(), 1), {defaultValue: null})

    let form: { [key: string]: any; } | null = response ? response['meeting_form_1'] : null
    if(!form){
      this.loading = false
      return
    }
    let step = this.retrieveStep(form)

    this.formService.updateForm(form)
    this.formService.setStep(step)

    this.loading = false

    if(this.helper.getMeetingForm() > 1)
      this.router.navigateByUrl(`form/(meeting-form:meeting_1/(meeting_1:summary))`)
    else if (step > 0)
      this.router.navigateByUrl(`form/(meeting-form:meeting_1/(meeting_1:${this.formService.getStep(1)}))`)
    
  }

  private retrieveStep(form: { [key: string]: any; }): number{

    let keys = Object.keys(form)

    if(keys.indexOf('meetingCompleted') >= 0)
      return 2
    else if(keys.indexOf('date') >= 0)
      return 1
    return 0
  }

}
